
export default {
    data() {
        return {
            defaultInfo: {
                title: "SkinOn",
                metaInfo: [
                    { charset: "utf-8" },
                    { httpEquiv: "X-UA-Compatible", content: "IE=edge" },
                    { name: "viewport", content: "width=device-width,initial-scale=1.0" },
                    { name: "description", content: "Офіційний дистриб’ютор професійних брендів RENEW, ALPHASCIENCE та GENIDENTITY" },
                    { name: "format-detection", content: "telephone=no" },
                    { name: "title", content: "" },
                    { property: "og:title", content: "" },
                    { property: "og:locale", content: "uk_UA" },
                    { property: "og:type", content: "website" },
                    { property: "og:description", content: "Офіційний дистриб’ютор професійних брендів RENEW, ALPHASCIENCE та GENIDENTITY" },
                ]
            },
            metaInfo: null
        }
    },
    created() {
        this.metaInfo = JSON.parse(JSON.stringify(this.defaultInfo));
        this.renderMetaInfo();
    },
    watch: {
      '$route'() {
        this.resetToDefault();
      }
    },
    methods: {
        changeTitle(title = "SkinOn") {
            this.metaInfo.title = title;
            document.title = title;
            this.renderMetaInfo();
        },
        renderMetaInfo() {
            document.title = this.metaInfo.title;

            this.metaInfo.metaInfo.forEach(meta => {
                let selector = '';
                let element = null;

                if (meta.charset) {
                    selector = 'meta[charset]';
                } else if (meta.httpEquiv) {
                    selector = `meta[http-equiv="${meta.httpEquiv}"]`;
                } else if (meta.property) {
                    selector = `meta[property="${meta.property}"]`;
                } else if (meta.name) {
                    selector = `meta[name="${meta.name}"]`;
                }

                if (selector) {
                    element = document.querySelector(selector);
                }

                if (element) {
                    if (meta.content !== undefined) {
                        element.setAttribute('content', meta.content);
                    }
                    if (meta.charset) {
                        element.setAttribute('charset', meta.charset);
                    }
                } else {
                    const newMeta = document.createElement('meta');

                    if (meta.charset) {
                        newMeta.setAttribute('charset', meta.charset);
                    }
                    if (meta.httpEquiv) {
                        newMeta.setAttribute('http-equiv', meta.httpEquiv);
                    }
                    if (meta.name) {
                        newMeta.setAttribute('name', meta.name);
                    }
                    if (meta.property) {
                        newMeta.setAttribute('property', meta.property);
                    }
                    if (meta.content !== undefined) {
                        newMeta.setAttribute('content', meta.content);
                    }

                    document.head.appendChild(newMeta);
                }
            });
        },
        resetToDefault() {
            this.removeNoIndexNoFollow();
            this.removeCanonical();
            this.removeBreadcrumbsJsonLd();
            this.removeFaqJsonLd();
            this.removeJsonLd('person-jsonld');
            this.removeJsonLd('article-jsonld');
            this.metaInfo = JSON.parse(JSON.stringify(this.defaultInfo));
            this.renderMetaInfo();
        },
        setJsonLd(id, data) {
            this.removeJsonLd(id);
            const script = document.createElement('script');
            script.setAttribute('type', 'application/ld+json');
            script.setAttribute('id', id);
            script.textContent = JSON.stringify(data);
            document.head.appendChild(script);
        },
        removeJsonLd(id) {
            const existing = document.getElementById(id);
            if (existing) existing.remove();
        },
        setBreadcrumbsJsonLd(data) {
            this.removeBreadcrumbsJsonLd();
            const script = document.createElement('script');
            script.setAttribute('type', 'application/ld+json');
            script.setAttribute('id', 'breadcrumbs-jsonld');
            script.textContent = JSON.stringify(data);
            document.head.appendChild(script);
        },
        removeBreadcrumbsJsonLd() {
            const existing = document.getElementById('breadcrumbs-jsonld');
            if (existing) existing.remove();
        },
        setFaqJsonLd(data) {
            this.removeFaqJsonLd();
            const script = document.createElement('script');
            script.setAttribute('type', 'application/ld+json');
            script.setAttribute('id', 'faq-jsonld');
            script.textContent = JSON.stringify(data);
            document.head.appendChild(script);
        },
        removeFaqJsonLd() {
            const existing = document.getElementById('faq-jsonld');
            if (existing) existing.remove();
        },
        setCanonical(url) {
            if (!url) return;
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', url);
        },
        removeCanonical() {
            const link = document.querySelector('link[rel="canonical"]');
            if (link) link.remove();
        },
        setPageMetaInfo(pageContent) {
          if(pageContent?.metaTitle && pageContent.metaTitle.length) {
            this.changeTitle(pageContent.metaTitle);
            this.changeMetaInfo("og:title", pageContent.metaTitle);
            this.changeMetaInfo("title", pageContent.metaTitle);
          }
          if(pageContent?.metaDescription && pageContent.metaDescription.length) {
            this.changeMetaInfo("og:description", pageContent.metaDescription);
            this.changeMetaInfo("description", pageContent.metaDescription);
          }
        },
        changeMetaInfo(field, value) {
            const fieldIndex = this.metaInfo.metaInfo.findIndex(meta => meta.property === field || meta.name === field);
            if (fieldIndex !== -1) {
                this.metaInfo.metaInfo[fieldIndex].content = value;
                this.renderMetaInfo();
            }
        },
        setRobots(content) {
            const robotsIndex = this.metaInfo.metaInfo.findIndex(meta => meta.name === 'robots');
            if (robotsIndex === -1) {
                this.metaInfo.metaInfo.push({ name: 'robots', content });
            } else {
                this.metaInfo.metaInfo[robotsIndex].content = content;
            }
            this.renderMetaInfo();
        },
        addNoIndexNoFollow() {
            this.setRobots('noindex, nofollow');
        },
        addIndexFollow() {
            this.setRobots('index, follow');
        },
        removeNoIndexNoFollow() {
            const robotsIndex = this.metaInfo.metaInfo.findIndex(meta => meta.name === 'robots');
            if (robotsIndex !== -1) {
                this.metaInfo.metaInfo.splice(robotsIndex, 1);
            }

            const robotsElement = document.querySelector('meta[name="robots"]');
            if (robotsElement) {
                robotsElement.remove();
            }
        }
    }
}
